import { gql } from 'graphql-tag'

export const FRAGMENT_NEW_MESSAGE_CONVERSATION = gql`
  fragment NewMessageConversation on conversation {
    id
    closed_at
    conversation_users {
      user {
        id
        username
        virtual_display_name
        virtual_avatar_url
      }
    }
  }
`
